import {RoleNameEnum} from "../../../../utils/types/common";

export type PermissionsAssignmentFilterKey = "has" | "none";

export type PermissionsManagementFilters = Readonly<{
  searchTerm: string;
  roleFilters: ReadonlyArray<RoleNameEnum>;
  permissionsFilters: ReadonlyArray<PermissionsAssignmentFilterKey>;
}>;

export const DEFAULT_PERMISSIONS_MANAGEMENT_FILTERS: PermissionsManagementFilters =
  {
    searchTerm: "",
    roleFilters: [],
    permissionsFilters: [],
  };
